/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PeriodicQaCheck } from '../../models/periodic-qa-check';

export interface GetManualProductionQaChecks$Params {
  productionOrderId: number;
}

export function getManualProductionQaChecks(http: HttpClient, rootUrl: string, params: GetManualProductionQaChecks$Params, context?: HttpContext): Observable<StrictHttpResponse<PeriodicQaCheck>> {
  const rb = new RequestBuilder(rootUrl, getManualProductionQaChecks.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PeriodicQaCheck>;
    })
  );
}

getManualProductionQaChecks.PATH = '/api/v1/QaCheck/{productionOrderId}/GetManualProductionQaChecks';
